import { getSecureKeyConfig } from './secureKeyConfig';

/* eslint-disable no-useless-escape */
const CryptoJS = require('crypto-js');
const cusSignStr = 'cusSignStr';
const MAOHAO = cusSignStr + 'MAOHAO';
const DOUHAO = cusSignStr + 'DOUHAO';
const YINHAO = cusSignStr + 'YINHAO';
const HUANHANG = cusSignStr + 'HUANHANG';
const regMaohao = new RegExp(MAOHAO, 'g');
const regDouhao = new RegExp(DOUHAO, 'g');
const regYinhao = new RegExp(YINHAO, 'g');
const regHuanhang = new RegExp(HUANHANG, 'g');
function BASE64(sin) {
  let str = CryptoJS.enc.Utf8.parse(sin);
  let base64 = CryptoJS.enc.Base64.stringify(str);
  return base64;
}
function replacer(key, value) {
  if (typeof value === 'string') {
    return value
      .replace(/:/g, MAOHAO)
      .replace(/,/g, DOUHAO)
      .replace(/\"/g, YINHAO)
      .replace(/\\n/g, HUANHANG);
  }
  if (typeof value === 'object') {
    for (const k in value) {
      if (typeof value[k] === 'string') {
        value[k] = value[k]
          .replace(/:/g, MAOHAO)
          .replace(/,/g, DOUHAO)
          .replace(/\"/g, YINHAO)
          .replace(/\\n/g, HUANHANG);
      } else if (typeof value[k] === 'object') {
        replacer('', value[k]);
      }
    }
  }
  return value;
}
/**
 *
 * @param {Object} params 传入的参数作升序排序
 */
function sortParams(p) {
  let params = JSON.parse(JSON.stringify(p));
  let sortArr = Object.keys(params).sort();
  let paramsUrl = '';
  sortArr.forEach((item, index) => {
    if (typeof params[item] == 'string') {
      paramsUrl += `${item}=${params[item]}`;
    } else {
      let pStr = JSON.stringify(params[item], replacer);
      pStr = pStr.replace(/"/g, '');
      pStr = pStr.replace(/:/g, '=');
      pStr = pStr.replace(/,/g, ', ');
      pStr = pStr.replace(/\\n/g, '\n');
      pStr = pStr.replace(/\\\\/g, '\\');
      pStr = pStr
        .replace(regMaohao, ':')
        .replace(regDouhao, ',')
        .replace(regYinhao, '"')
        .replace(regHuanhang, '\\n');
      paramsUrl += `${item}=${pStr}`;
    }
    if (index !== sortArr.length - 1) {
      paramsUrl += '&';
    }
  });
  return paramsUrl;
}

export function signForParams(params = {}) {
  try {
    const secureConfig = getSecureKeyConfig();
    const { salt } = secureConfig;
    let sortStr = salt;
    sortStr = sortParams(params) + salt;
    let base64str = BASE64(sortStr);
    let md5Str = CryptoJS.MD5(base64str).toString();
    return md5Str;
  } catch (error) {}
}
